export default "__VITE_ASSET__270beeec__"